import { Form, Modal } from "antd";
import React from "react";
import { CreateRadiologyPointPollutantDto } from "../../../api";
import { radiologyPointPollutantsColumns } from "../form/columns";

interface RadiologyPointPollutantFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateRadiologyPointPollutant: (values: CreateRadiologyPointPollutantDto) => void;
}

export const RadiologyPointPollutantForm: React.FC<RadiologyPointPollutantFormProps> = ({ visible, setVisible, onCreateRadiologyPointPollutant }) => {
  const [form] = Form.useForm<CreateRadiologyPointPollutantDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateRadiologyPointPollutant}>
        {radiologyPointPollutantsColumns.map(({ title, dataIndex, rules, inputNode }, index) => (
          <Form.Item label={title} name={dataIndex} rules={rules} key={index}>
            {inputNode}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
